import { Route, Routes } from "react-router-dom";

import RequireAuth from "@/components/auth/RequireAuth";
import RequireAdminAuth from "@/components/auth/RequireAdminAuth";
import Layout from "@/components/Layout";
import Access from "@/pages/Access";
import AdminLogin from "@/pages/AdminLogin";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminSources from "@/pages/AdminSources";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/access" element={<Access />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAdminAuth>
              <AdminSources />
            </RequireAdminAuth>
          }
        />
        <Route
          path="/admin/newsletter"
          element={
            <RequireAdminAuth>
              <AdminNewsletter />
            </RequireAdminAuth>
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="/dia/:fecha"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
    